import React from "react";
import { Flex } from "@chakra-ui/layout";
import colors from "theme/colors";

function ButtonResumoPorCategoria({ onClick }: { onClick: () => any }) {
  return (
    <Flex
      as="button"
      color={colors.blue}
      fontSize="16px"
      gap={2}
      ml="auto"
      align="center"
      onClick={onClick}
      cursor="pointer"
      userSelect="none"
      _hover={{
        textDecoration: "underline",
      }}
    >
      Resumo por categoria
    </Flex>
  );
}

export default ButtonResumoPorCategoria;
